import { render, staticRenderFns } from "./Commission_Category.vue?vue&type=template&id=834eddfa&scoped=true&"
import script from "./Commission_Category.vue?vue&type=script&lang=js&"
export * from "./Commission_Category.vue?vue&type=script&lang=js&"
import style0 from "./Commission_Category.vue?vue&type=style&index=0&id=834eddfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "834eddfa",
  null
  
)

export default component.exports